import React from "react";
import classNames from "classnames";

// because of how tailwind JIT works, we need to use the full class names
// instead of interpolating the color
const colorClasses = {
    green: 'text-green-700 bg-green-100 border-green-500',
    red: 'text-red-700 bg-red-100 border-red-500',
    yellow: 'text-yellow-700 bg-yellow-100 border-yellow-500',
    blue: 'text-blue-700 bg-blue-100 border-blue-500',
    gray: 'text-gray-700 bg-gray-100 border-gray-500',
};

export const Chip = ({ color, text, className }: {
    color: keyof typeof colorClasses,
    text: string,
    className?: string
}) => {
    return (
        <span className={classNames(
            'inline-flex items-center rounded-md px-2 py-1 text-base font-medium',
            colorClasses[color],
            className
        )}>
            {text}
        </span>
    );
};